<template>
  <div v-if="params.value !== undefined" :class="$style.container">
    <router-link :to="{ name: routerName, params: {id: params.data.account_number}}" :class="$style.link">
      {{ params.value }}
    </router-link>

    <div :class="$style.icons">
      <div v-if="showIcons && privileges.length" :class="$style.privileges">
        <vs-tooltip title="Льготы" :text="privilegesText" :active="true">
          <app-icon name="PercentIcon" size="16px" />
          <!-- Фикс появления https://github.com/lusaxweb/vuesax/issues/490 -->
          <span>&nbsp;</span>
        </vs-tooltip>
      </div>

      <div v-if="showIcons && !params.data.pass_date" title="У помещения нет даты акта приема передачи">
        <app-tag color="danger" class="ag-table-cell-tag">
          <app-icon name="AlertIcon" size="16px" />
        </app-tag>
      </div>

      <div v-else-if="showIcons && params.data.is_archive" title="Помещение в архиве">
        <app-tag color="warning" class="ag-table-cell-tag">
          <app-icon name="FolderIcon" size="16px" />
        </app-tag>
      </div>
    </div>
  </div>
  <div v-else :class="$style.container">
    Загрузка...
  </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name:     "AccountNumberRenderer",
  computed: {
    showIcons() {
      return !!this.params.withIcons;
    },
    routerName() {
      return this.params.routerName ? this.params.routerName : 'uc_b_account';
    },
    privileges() {
      const list = [];
      const extract = ( user ) => user.user.privileges.forEach(privilege => {
        list.push(privilege);
      });
      this.params.owners_u_a.forEach(extract);
      this.params.other_users.forEach(extract);
      return list;
    },
    privilegesText() {
      return this.privileges
        .map(( privilege ) => privilege.name)
        .join(', ');
    },
  },
});
</script>

<style lang="scss" module>
.container {
  padding: 0 10px;
  height: 100%;
  display: flex;
  align-items: center;
}

.link {
  color: color(content-color);

  &:hover {
    color: color(primary);
    text-decoration: underline;
  }

  &:visited {
    color: color(content-color);
  }
}

.icons {
  margin-left: auto;
}

.privileges {
  color: #d79e49;
}

.ag-table-account-number-renderer {
  position: relative;
  /*flex-wrap: wrap;*/
  &__tag {
    position: absolute;
    left: 5px;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    justify-content: center;

    &--privileges {
      left: auto;
      right: 5px;
      color: #d79e49;
    }
  }

  &__value {
    /*width: 100%;*/
    font: inherit;
  }
}
</style>
